import {
  CompaniesCountBody,
  CompaniesSearchBody,
  CompanyFeaturesQuery,
} from "@reflag/shared/companyAPI";

const qk = {
  list: (
    appId?: string,
    envId?: string,
    params?: Omit<CompaniesSearchBody, "envId">,
  ) =>
    [
      "apps",
      appId,
      "environments",
      envId,
      "companies",
      ...(params ? [params] : []),
    ] as const,

  count: (
    appId?: string,
    envId?: string,
    params?: Omit<CompaniesCountBody, "envId">,
  ) =>
    [...qk.list(appId, envId), "count", ...(params ? [params] : [])] as const,

  single: (appId?: string, envId?: string, companyId?: string) =>
    [...qk.list(appId, envId), companyId] as const,

  flags: (
    appId?: string,
    envId?: string,
    companyId?: string,
    params?: Omit<CompanyFeaturesQuery, "envId">,
  ) =>
    [
      ...qk.single(appId, envId, companyId),
      "flags",
      ...(params ? [params] : []),
    ] as const,
  // Backward compatibility for existing callers.
  features: (
    appId?: string,
    envId?: string,
    companyId?: string,
    params?: Omit<CompanyFeaturesQuery, "envId">,
  ) => qk.flags(appId, envId, companyId, params),

  attributes: (appId?: string, envId?: string, filter?: string) =>
    [...qk.list(appId, envId), "attributes", filter] as const,

  companyNames: (
    appId?: string,
    envId?: string,
    params: Record<string, any> = {},
  ) =>
    [...qk.list(appId, envId), "names", ...(params ? [params] : [])] as const,
};

export { qk as companyQueryKeys };
